
import {AcademicDocument} from '../academic-document/academic-document.model';
import {ReportCard} from '../report-card/report-card.model';

export enum SaisineStatus {
    'IN_PROGRESS',
    'TO_CHECK',
    'REJECTED',
    'CHECKED',
    'TREATED',
    'ABANDONED',
    'CLOSED',
    'CANCELED'
};
import { RefusedMaster } from '../refused-master';
import { MasterProposal } from '../master-proposal';
import { Rejection } from '../rejection';
import { SaisineComment } from '../saisine-comment';

export class Saisine {
    constructor(
        public id?: number,
        public lastName?: string,
        public firstName?: string,
        public birthDate?: any,
        public birthPlace?: string,
        public sex?: string,
        public streetAddress?: string,
        public student?: any,
        public postalCode?: string,
        public city?: string,
        public useName?: string,
        public firstName2?: string,
        public firstName3?: string,
        public hasDisability?: boolean,
        public disabilityResponses?: Object,
        public licenceTitle?: string,
        public licenceAcademicRegionLabel?: string,
        public licenceAcademyCode?: string,
        public licenceAcademyLabel?: string,
        public licenceSchoolUai?: string,
        public licenceSchoolLabel?: string,
        public licenceDate?: string,
        public numberRefusedMaster?: number,
        public creationDate?: any,
        public lastModificationDate?: any,
        public submitDate?: any,
        public firstSubmitDate?: any,
        public checkingDate?: any,
        public closureDate?: any,
        public abandonedDate?: any,
        public treatedDate?: any,
        public canceledDate?: any,
        public status?: SaisineStatus,
        public licenceDocumentUserBlobId?: number,
        public licenceDocumentUserBlobFilename?: string,
        public cvDocumentUserBlobId?: number,
        public cvDocumentUserBlobFilename?: string,
        public motivationLetterDocumentUserBlobId?: number,
        public motivationLetterUserBlobFilename?: string,
        public refusedMasters?: RefusedMaster[],
        public masterProposals?: MasterProposal[],
        public rejections?: Rejection[],
        public academicDocuments?: AcademicDocument[],
        public reportCards?: ReportCard[],
        public inebea?: string,
        public numberStudentProposals?: number,
        public numberStudentRefused?: number,
        public numberStudentConfirmed?: number,
        public numberStudentProposalsDisplayed?: string,
        public numberStudentRefusedDisplayed?: string,
        public numberStudentConfirmedDisplayed?: string,
        public reference?: string,
        public newFlag?: Boolean,
        public saisineComment?: SaisineComment[],
        public campaign?: string
    ) {
        this.refusedMasters = [];
        this.masterProposals = [];
        this.rejections = [];
        this.academicDocuments = [];
        this.reportCards = [];
        this.licenceDate = '';
        this.disabilityResponses = { };
        this.saisineComment = [];
      }

    hasStatus(s: SaisineStatus) {
        return s === this.status;
    }

    hasAtLeastOneRejection(): Boolean {
        return this.rejections && this.rejections.length > 0;
    }

    sortedRejections(): Rejection[] {
        if (this.rejections) {
            return this.rejections.sort((r1, r2) => {
                let r1Time = r1.date.getTime();
                let r2Time = r2.date.getTime();
                if (r1Time > r2Time) {
                    return -1;
                } else if (r1Time < r2Time) {
                    return 1;
                } else {
                    return 0;
                }
            });
        } else {
            return [];
        }
    }

    mostRecentRejection(): Rejection {
        let sortedRejects = this.sortedRejections();
        if (sortedRejects) {
            return sortedRejects[0];
        } else {
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/saisine/saisine.model.ts